import { graphql } from "@/data-access/graphql";
import { PageInfoFragment } from "@/data-access/shared/fragments/feed-article-projection-fragments";
import {
  TemplateLayoutFragment,
  TemplateLayoutSummaryFragment,
} from "../fragments/template-layout-fragments";

export const ListTemplateLayouts = graphql(
  `
    query listTemplateLayouts(
      $filters: BriefingTemplateFilter
      $first: Int
      $after: String
    ) {
      templateLayouts(filters: $filters, first: $first, after: $after) {
        edges {
          cursor
          node {
            ...TemplateLayoutSummaryFragment
          }
        }
        pageInfo {
          ...PageInfoFragment
        }
      }
    }
  `,
  [TemplateLayoutSummaryFragment, PageInfoFragment],
);

export const GetTemplateLayout = graphql(
  `
    query getTemplateLayout($id: ID!) {
      templateLayouts(filters: { id: $id }, first: 1) {
        edges {
          node {
            ...TemplateLayoutFragment
          }
        }
      }
    }
  `,
  [TemplateLayoutFragment],
);

export const CreateTemplateLayout = graphql(
  `
    mutation createTemplateLayout($input: TemplateLayoutCreateInput!) {
      createTemplateLayout(input: $input) {
        ... on TemplateLayout {
          ...TemplateLayoutFragment
        }
        ... on OperationInfo {
          __typename
          messages {
            code
            field
            kind
            message
          }
        }
      }
    }
  `,
  [TemplateLayoutFragment],
);

export const UpdateTemplateLayout = graphql(
  `
    mutation updateTemplateLayout($input: TemplateLayoutUpdateInput!) {
      updateTemplateLayout(input: $input) {
        ... on TemplateLayout {
          ...TemplateLayoutFragment
        }
        ... on OperationInfo {
          __typename
          messages {
            code
            field
            kind
            message
          }
        }
      }
    }
  `,
  [TemplateLayoutFragment],
);

export const ArchiveBriefingTemplate = graphql(`
  mutation archiveBriefingTemplate($id: ID!) {
    archiveBriefingTemplate(id: $id) {
      ... on BriefingTemplate {
        __typename
        id
      }
      ... on OperationInfo {
        __typename
        messages {
          code
          field
          kind
          message
        }
      }
    }
  }
`);

export const PublishBriefingTemplate = graphql(`
  mutation publishBriefingTemplate($id: ID!) {
    publishBriefingTemplate(id: $id) {
      ... on BriefingTemplate {
        __typename
        id
      }
      ... on OperationInfo {
        __typename
        messages {
          code
          field
          kind
          message
        }
      }
    }
  }
`);
